
import { Button } from "@/components/ui/button";
import { Bell, ArrowLeft } from "lucide-react";
import { Header } from "@/components/layout/Header";
import { NotificationList } from "@/components/notifications/NotificationList";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-4 sm:py-8">
        <Button
          variant="ghost"
          onClick={() => navigate("/dashboard")}
          className="mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Button>

        <div className="flex items-center gap-4 mb-6">
          <h1 className="text-xl sm:text-2xl font-bold flex items-center gap-2">
            <Bell className="h-5 w-5 sm:h-6 sm:w-6" />
            Notifications
          </h1>
        </div>

        <NotificationList />
      </main>
    </div>
  );
};

export default Notifications;
